import { render, staticRenderFns } from "./promotion-dates-form-wrapper.vue?vue&type=template&id=3d1d20d8"
import script from "./promotion-dates-form-wrapper.vue?vue&type=script&lang=js"
export * from "./promotion-dates-form-wrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports